const NS = 'SiteHeaderWidget';
const CLS = 'siteHeaderWidget';
import { overlay } from '../../../../global/js/ara/overlay';

export class SiteHeaderWidget {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.$siteHeaderMenuWidget = this.$element.find('[data-wg="SiteHeaderMenuWidget"]');
		this.$siteHeaderSearchBarWidget = this.$element.find('[data-wg="SiteHeaderSearchBarWidget"]');
		$(document.body).append(this.$siteHeaderMenuWidget);
		$(document.body).append(this.$siteHeaderSearchBarWidget);
		this.overlay = overlay;

		this.$siteHeaderBlockWrapper = $('.siteHeaderBlock-wrapper');


		this.$btnMenu = this.$element.find(`.${CLS}-btn--menu`);
		this.$btnMenu.on('click', () => {
			this.$siteHeaderBlockWrapper.removeClass('fixed');

			$('.siteHeaderWidget-btn--menu .siteHeaderWidget-btn-icon').toggleClass('icon--menu icon--close');

			if(this.$siteHeaderMenuWidget.attr('data-active') === 'false') {
				destroyItems({
					searchBar: true
				});

				this.overlay.create({
					onDestroyCallback: destroyItems,
					transparent: true
				});

				this.$siteHeaderMenuWidget.trigger('siteHeaderMenuWidget.open', {});
				this.$btnMenu.addClass('active');
				this.$siteHeaderBlockWrapper.addClass('fixed');

				let $searchIcon = $('.siteHeaderWidget-btn--search .siteHeaderWidget-btn-icon');
				if($searchIcon.hasClass('icon--close')) {
					$searchIcon.removeClass('icon--close');
					$searchIcon.addClass('icon--search');
				}

			}
			else {
				destroyItems();
				this.$siteHeaderBlockWrapper.removeClass('fixed');

			}
		});

		this.$btnSearch = this.$element.find(`.${CLS}-btn--search`);
		this.$btnSearch.on('click', () => {
			this.$siteHeaderBlockWrapper.removeClass('fixed');

			$('.siteHeaderWidget-btn--search .siteHeaderWidget-btn-icon').toggleClass('icon--search icon--close');


			if(this.$siteHeaderSearchBarWidget.attr('data-active') === 'false') {
				destroyItems({
					menu: true
				});

				// Create overlay
				this.overlay.create({
					onDestroyCallback: destroyItems,
					transparent: true
				});

				this.$siteHeaderSearchBarWidget.trigger('siteHeaderSearchBarWidget.open', {});
				this.$btnSearch.addClass('active');

				let $menuIcon = $('.siteHeaderWidget-btn--menu .siteHeaderWidget-btn-icon');
				if($menuIcon.hasClass('icon--close')) {
					$menuIcon.removeClass('icon--close');
					$menuIcon.addClass('icon--menu');
				}

				this.$siteHeaderBlockWrapper.addClass('fixed');

				// console.log($('.siteHeaderSearchBarWidget .generalSearchAutoCompleteWidget-searchInput'));
				$('.siteHeaderSearchBarWidget .generalSearchAutoCompleteWidget-searchInput')[0].focus();
			}
			else {
				destroyItems();
				this.$siteHeaderBlockWrapper.removeClass('fixed');

			}
		});

		let destroyItems = (include = { menu: true, searchBar: true }) => {

			this.overlay.destroy();

			if(include.searchBar) {
				this.$siteHeaderSearchBarWidget.trigger('siteHeaderSearchBarWidget.close', {});
				this.$btnSearch.removeClass('active');
				this.$siteHeaderBlockWrapper.removeClass('fixed');

				let $searchIcon = $('.siteHeaderWidget-btn--search .siteHeaderWidget-btn-icon');
				$searchIcon.removeClass('icon--close');
				$searchIcon.addClass('icon--search');

			}

			if(include.menu) {
				this.$siteHeaderMenuWidget.trigger('siteHeaderMenuWidget.close', {});
				this.$btnMenu.removeClass('active');
			}
		};
	}
}
